export const copilotDropdownFeatureFlags = ['email-translation'] as const;
